import api from './auth';
import { ServerStats, SystemStatus, NetConfigStats, BandwidthPoint } from '../types/api';

// 获取服务器统计信息
export const getServerStats = () => {
  return api.get<ServerStats>('/dashboard/stats');
};

// 获取 PPP拨号/静态IP 在线离线统计
export const getNetConfigStats = () => {
  return api.get<NetConfigStats>('/dashboard/net-config-stats');
};

// 获取当前权限范围内的带宽历史曲线（默认最近24小时，hours 可传 1~24）
export const getBandwidthHistory = (hours = 24) => {
  return api.get<BandwidthPoint[]>('/dashboard/bandwidth-history', { params: { hours } });
};

// 获取最近任务
export const getRecentTasks = (limit = 5) => {
  return api.get(`/dashboard/recent-tasks?limit=${limit}`);
};

// 获取系统状态
export const getSystemStatus = () => {
  return api.get<SystemStatus>('/dashboard/system-status');
};
